import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-companies-sales-network-dialog',
  templateUrl: './companies-sales-network-dialog.component.html',
  styleUrls: ['./companies-sales-network-dialog.component.scss'],
})
export class CompaniesSalesNetworkDialogComponent {
  company_id: string;
  company_sales_network_id: string;
  set_sales_network_form_group: FormGroup = this.form_service.set_sales_network_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_company_edit_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesSalesNetworkDialogComponent>,
    private form_service: FormService,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company_id = data.company_id;
    this.company_sales_network_id = data.sales_network_id;
  }

  ngOnInit(): void {
    this.set_sales_network_form_group
      .get(this.form_service.sales_network_id_label)
      ?.setValue(this.company_sales_network_id);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid()) {
      const sales_network_id = this.set_sales_network_form_group.get(this.form_service.sales_network_id_label)?.value;
      this.setSalesNetworkId(this.company_id, sales_network_id);
    }
  }

  setSalesNetworkId(company_id: string, sales_network_id: string): void {
    this.is_company_edit_running = true;
    this.companies_service.setSalesNetworkId(company_id, sales_network_id).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_company_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_company_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.set_sales_network_form_group);
  }
}
